var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"home-banner"},[_c('Banner')],1),_c('WrapNotice'),_c('GameConsole'),_c('GameList'),_c('GamePrizePool'),_c('GamePopular'),_c('GameInner'),_c('MobileCode'),_c('ServiceAdvantage'),_c('JackpotNew')],1)}
var staticRenderFns = []

export { render, staticRenderFns }